module.exports = '<svg width="24" height="32" viewBox="0 0 24 32"><path d="M24 2c0-1.106-.894-2-2-2H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V2zm-9.98 25a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v2zM20 20H4V4h16v16z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/smart-phone-2.js
// module id = 1425
// module chunks = 14